module.exports = __webpack_public_path__ + "static/media/icon-plus.ac45b0cd.svg";